<div class="check-in-table-container">
  @if (loading) {
    <div class="flex justify-center items-center h-64">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
      <p-table
        (onLazyLoad)="onPageChange($event)"
        [currentPageReportTemplate]="'checkInTable.pagination' | translate"
        [first]="first"
        [lazy]="true"
        [loading]="loading"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [totalRecords]="totalRecords"
        [value]="checkIns"
        stripedRows
      >
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'checkInTable.columns.reservation' | translate }}</th>
            <th>{{ 'checkInTable.columns.guest' | translate }}</th>
            <th>{{ 'checkInTable.columns.room' | translate }}</th>
            <th>{{ 'checkInTable.columns.roomType' | translate }}</th>
            <th>{{ 'checkInTable.columns.checkInDate' | translate }}</th>
            <th>{{ 'checkInTable.columns.time' | translate }}</th>
            <th>{{ 'checkInTable.columns.status' | translate }}</th>
            <th>{{ 'checkInTable.columns.actions' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template let-entry pTemplate="body">
          <tr>
            <td>
              <span class="font-semibold text-primary-600">{{ entry.reservationNumber }}</span>
            </td>
            <td>
              <div>
                <div class="font-semibold">{{ entry.guestName }}</div>
                <div class="text-xs text-gray-500">{{ entry.email }}</div>
              </div>
            </td>
            <td>
              <span class="font-semibold">{{ entry.roomNumber }}</span>
            </td>
            <td>
              <span>{{ entry.roomType }}</span>
            </td>
            <td>
              <span>{{ entry.checkInDate }}</span>
            </td>
            <td>
              <span>{{ entry.checkInTime }}</span>
            </td>
            <td>
              <p-tag [severity]="getStatusSeverity(entry.status)" [value]="entry.status"></p-tag>
            </td>
            <td>
              <div class="flex gap-2">
                <!-- Process Check-in -->
                @if (entry.status === 'pending') {
                  <p-button
                    (onClick)="onProcessCheckIn(entry)"
                    [raised]="true"
                    icon="pi pi-check"
                    [pTooltip]="'checkInTable.actions.processCheckIn' | translate"
                    severity="success"
                    size="small"
                    tooltipPosition="top"
                    variant="outlined"
                  />
                }
                <!-- Cancel -->
                @if (entry.status === 'pending') {
                  <p-button
                    (onClick)="onCancelCheckIn(entry)"
                    [raised]="true"
                    icon="pi pi-times"
                    [pTooltip]="'checkInTable.actions.cancelCheckIn' | translate"
                    severity="danger"
                    size="small"
                    tooltipPosition="top"
                    variant="outlined"
                  />
                }
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="text-center p-4" colspan="8">
              <div class="text-gray-500 dark:text-gray-400">
                {{ 'checkInTable.emptyPending' | translate }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
